import React, { ReactNode } from "react";
import { Button, Card, Tag, Empty, Spin, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Text } = Typography;
// ── EmptyState ────────────────────────────────────────────────
// Consistent empty states with optional CTA.
//
// Usage:
//   <EmptyState
//     title="No patients found"
//     description="Add your first patient to get started"
//     action={{ label: "Add Patient", onClick: () => {} }}
//   />

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: { label: string; icon?: ReactNode; onClick: () => void };
  style?: React.CSSProperties;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No data", description, icon, action, style,
}) => (
  <Empty
    style={{ padding: "32px 0", ...style }}
    image={icon ?? <InboxOutlined style={{ fontSize: 40, color: "var(--mg-text-secondary)", opacity: 0.4 }} />}
    description={
      <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "center" }}>
        <Text style={{ fontSize: 14, fontWeight: 500, color: "var(--mg-text)" }}>{title}</Text>
        {description && <Text type="secondary" style={{ fontSize: 11 }}>{description}</Text>}
      </div>
    }
  >
    {action && (
      <Button
        type="primary"
        icon={action.icon}
        onClick={action.onClick}
      >
        {action.label}
      </Button>
    )}
  </Empty>
);

export default EmptyState;